import get from 'lodash-es/get';
import React from 'react';

import { lineItemFormText } from '../../constants/lineItems';
import { useConstants } from '../../hooks/useConstants';
import CheckboxArray from '../forms/CheckboxArray';
import FormSection from '../forms/FormSection';
import FormSubsection from '../forms/FormSubsection';

function LineItemReportingSection() {
  const { constants } = useConstants();

  const omitOptions = ['placed', 'celtra', 'wrapup', 'purchasebased'];
  const options = get(constants, 'INSERTION_ORDER.COST_INCURRING_FEATURES', [])
    .filter((item) => !omitOptions.includes(item[0]))
    .map((item) => ({
      value: item[0],
      label: item[1],
    }));

  return (
    <FormSection title={lineItemFormText.sectionTitles.reporting}>
      <FormSubsection title={lineItemFormText.subsectionTitles.costFeatures}>
        <CheckboxArray row name="costIncurringFeatures" options={options} />
      </FormSubsection>
    </FormSection>
  );
}

export default LineItemReportingSection;
